import React, { Component } from 'react';
import Message from './ValidationMessage';
import InlineField from './InlineField';

export class CurrencyField extends Component {
  numberBetween(min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return (value, previousValue, allValues) => {
      return value < Number(min)
        ? Number(min)
        : value > Number(max)
        ? Number(max)
        : Number(value);
    };
  }

  render() {
    let {
      amount,
      currency,
      currencyCode,
      id,
      input,
      intl,
      label,
      placeholder,
      required,
      allowNegative = false,
      disabled = false,
      displayType = 'edit',
      translation,
      meta: { touched, error, warning },
    } = this.props;
    let showError = touched && error ? 'error' : '';
    
    if (intl && translation) {
      const labelObj = translation.label;
      const placeholderObj = translation.placeholder;
      if (labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
      if (placeholderObj && placeholderObj.message) {
        placeholder = intl.formatMessage(
          placeholderObj.message,
          placeholderObj.params,
        );
      }
    }

    if (displayType === 'inline') {
      let content;

      content = intl.formatNumber(amount ? amount : input.value, {
        currency: (currency || currencyCode || 'USD').toUpperCase(),
        style: 'currency',
      });

      return (
        <InlineField
          fieldType="renderCurrency"
          content={content}
          label={label}
          translation={translation}
          id={id}
        />
      );
    }

    input.value = CURRENCY({
      allowNegative,
      currencyCode: currency || currencyCode,
    })(input.value);

    return (
      <div className={`${required && 'required'} field ${showError}`}>
        {label && <label>{label}</label>}
        <div>
          <input
            {...input}
            disabled={disabled}
            id={id}
            placeholder={placeholder}
            type="number"
          />
          <Message show={touched} message={error} />
          <Message show={touched} message={warning} />
        </div>
      </div>
    );
  }
}

export function CURRENCY({
  allowNegative = false,
  currencyCode = 'USD',
  locales = 'en-US',
} = {}) {
  return value => {
    if (value === '') {
      return Number(value);
    }

    const amount = allowNegative ? Number(value) : Math.abs(Number(value));
    const opts = {
      style: 'currency',
      currencyDisplay: 'code',
      useGrouping: false,
      currency: currencyCode.toUpperCase(),
    };

    const formattedNumber = new Intl.NumberFormat(locales, opts).format(amount);
    return Number(formattedNumber.replace(currencyCode, '').replace(/\s/g, ''));
  };
}

export const asCurrency = (amount, allowNegative, currencyCode) => {
  if (allowNegative) return CURRENCY({ allowNegative, currencyCode })(amount);
  return CURRENCY()(amount);
};
